export default {
  'types.lvl0': {
    isOpen: true,
    widgetType: 'checkbox',
  },
  experts: {
    title: 'Experts',
    widgetType: 'checkbox',
  },
}
